import { render } from "./Endorsements.vue?vue&type=template&id=2d179709"
import script from "./Endorsements.vue?vue&type=script&lang=js"
export * from "./Endorsements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__